import { useTranslation } from 'react-i18next'
import { IApplicationState } from 'Store/types'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import FileDownloader from 'Components/FileDownloader'
import VisitsApiPaths from 'Application/Visits/Constants/VisitsApiPaths'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import React from 'react'
import Icon from 'Components/Icon'

const FinalPage = () => {
  const [t] = useTranslation()
  const { visitId, visitStatus } = useSelector((store: IApplicationState) => store.visits.newVisit)
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <div className="flex justify-between items-center h-16 px-6 shrink-0">
        <div className="flex justify-between items-center gap-2">
          <div className="text-lg font-bold pl-2">{t('FINAL')}</div>
        </div>
        <div className="flex justify-between items-center">
          <div className="relative">
            {/* <svg className="w-6 h-6 text-gray-600">
              <use href="#close"></use>
            </svg> */}
          </div>
        </div>
      </div>

      <div className="flex flex-col grow overflow-auto">
        <div className="px-6 pb-6">
          <div className="text-base font-bold text-success mb-4">
            {visitStatus == 4
              ? t('THE-INSPECTION-WITH-MISSING-DOCUMENT-STATUS-HAS-BEEN-REGISTERED')
              : t('THE-APPRAISAL-HAS-BEEN-SUCCESSFULLY-REGISTERED')}
          </div>
          <p className="text-sm mb-8">
            {t('TO-VIEW-AND-TRACK-THE-REGISTERED-INSPECTIONS,-GO-TO-THE-INSPECTIONS-MENU')}
          </p>

          <img src="assets/images/victory.svg" className="w-full max-h-80 mx-auto" />
        </div>
      </div>

      <div className="cta">
        <FileDownloader
          url={`${VisitsApiPaths.GetVisitSummaryReportPdfFile}${visitId}`}
          title={t('VISIT_FILE')}
          disabled={visitStatus == 4}
          fileName={'VisitFile.pdf'}
        />
        <button
          className="btn btn-text-primary btn-lg flex gap-1 items-center justify-center"
          onClick={() => navigate(VisitsPaths.NewVisit)}
        >
          <Icon name="add" className="w-6 h-6" />
          {t('NEW_VISIT')}
        </button>
      </div>
    </React.Fragment>
  )
}

export default FinalPage
